import { createRootRoute, createRoute, createRouter, Navigate, redirect } from "@tanstack/react-router";
import { AppShell, RootLayout } from "@/layout/root-layout";
import { ChangelogPage } from "@/pages/changelog-page";
import { DashboardPage } from "@/pages/dashboard-page";
import { IngestionPage } from "@/pages/ingestion-page";
import { LoginPage } from "@/pages/login-page";
import { NovautPage } from "@/pages/novaut-page";
import { ProductsPage } from "@/pages/products-page";
import { ShopifySyncPage } from "@/pages/shopify-sync-page";

const rootRoute = createRootRoute({
  component: RootLayout,
  notFoundComponent: () => <Navigate to="/dashboard" />,
});

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  beforeLoad: () => {
    throw redirect({ to: "/dashboard" });
  },
});

const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/login",
  component: LoginPage,
});

// Opened in a new tab by the version in the sidebar footer, so it sits outside
// the auth guard and the app chrome.
const changelogRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/changelog",
  component: ChangelogPage,
});

// Layout route (no path): wraps the private area in the auth guard + chrome.
const appRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: "app",
  component: AppShell,
});

const dashboardRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/dashboard",
  component: DashboardPage,
});

const ingestionRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/ingestion",
  component: IngestionPage,
});

const shopifySyncRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/shopify-sync",
  component: ShopifySyncPage,
});

const productsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/products",
  component: ProductsPage,
});

const novautRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/novaut",
  component: NovautPage,
});

const routeTree = rootRoute.addChildren([
  indexRoute,
  loginRoute,
  changelogRoute,
  appRoute.addChildren([
    dashboardRoute,
    ingestionRoute,
    shopifySyncRoute,
    productsRoute,
    novautRoute,
  ]),
]);

export const router = createRouter({
  routeTree,
  basepath: import.meta.env.BASE_URL,
  defaultPreload: "intent",
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
